import React, { FC } from "react";

import { Loading } from "ui-library/atoms";
import { StyledDataTableWrapper } from "ui-library/Styled";

import { TableHeader } from "./TableHeader";

export interface MultiDataTableWrapperProps {
    actions?: React.ReactNode;
    icon?: string;
    isLoading?: boolean;
    preContent?: React.ReactNode;
    title?: string;
    withWrapper?: boolean;
    children: React.ReactNode;
}

export const MultiDataTableWrapper: FC<MultiDataTableWrapperProps> = ({
    actions = null,
    icon = null,
    isLoading = false,
    preContent,
    title = null,
    withWrapper,
    children,
}) => {
    return (
        <StyledDataTableWrapper $withWrapper={withWrapper}>
            <TableHeader actions={actions} icon={icon} isEmpty={false} isLoading={isLoading} title={title} />

            {preContent && preContent}

            <Loading loading={isLoading}>{children}</Loading>
        </StyledDataTableWrapper>
    );
};
